import React from "react";
import { useLabelsContext } from "../../context/LabelsContext";
import { useClubContext } from "../../context/ClubContext";

type ClubTermsLinkProps = {
	setIsModalOpen: (isModalOpen: boolean) => void;
};

export const ClubTermsLink: React.FC<ClubTermsLinkProps> = ({
	setIsModalOpen,
}: ClubTermsLinkProps) => {
	const { labels } = useLabelsContext();
	const { club } = useClubContext();

	const termsLinkLabel: string = labels?.["AgreeToClubTermsEnd"] || "";
	const termsText: string | null = club?.clubTermsText || null;
	const termsLink: string | null = club?.clubTermsLink || null;

	if (!termsLink && !termsText) return null;

	if (termsText) {
		return (
			<button
				type='button'
				className='club-terms-modal-btn'
				onClick={() => setIsModalOpen(true)}
			>
				{termsLinkLabel}
			</button>
		);
	}
	if (termsLink) {
		return (
			<a
				href={termsLink}
				target='_blank'
				rel='noopener noreferrer'
				style={{ color: "inherit" }}
			>
				{termsLinkLabel}
			</a>
		);
	}

	return null;
};
